import React from 'react'

const NotBottomMenu = () => {
    return (
        <div>
            {new Date().getFullYear()} &copy; Liberyus
        </div>
    )
}

export default NotBottomMenu
